import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import InfoSpot from '@/components/InfoSpot';
import PortalShellV2 from '@/components/PortalShellV2';

function Field({ label, value, delay = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay }}
    >
      <p className="text-[12px] font-body font-semibold text-[#0A0A0A] mb-1">{label}</p>
      <p className="text-[13px] font-body text-[#6B7280]">{value}</p>
    </motion.div>
  );
}

export default function FacilityDetailV2Scene() {
  return (
    <PortalShellV2 variant="sidebar" menu="lite" activeGroup="Manage" activeSub="Facility" showLogout>
      <div data-testid="scene-facility-detail-v2" className="px-10 pt-7 pb-10">
        <div className="max-w-5xl">
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-[12.5px] font-body text-[#6B7280] mb-3 flex items-center gap-1">
            Manage <ChevronRight size={11} className="inline" /> Facilities <ChevronRight size={11} className="inline" /> <span className="text-[#0A0A0A]">Burjeel-AlNahyan</span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }}
            className="font-heading font-extrabold text-[42px] leading-tight tracking-tight text-[#0A0A0A] flex items-center gap-2"
          >
            Burjeel-AlNahyan
            <InfoSpot
              text="Facility detail page — shows the facility's basic info, address, licensing and the parent organisation it belongs to."
              position="right"
              autoOpenAt={0.8}
              autoCloseAfter={3.0}
              glowAt={0.5}
            />
          </motion.h1>

          <div className="border-b border-[#E5E7EB] mt-4 mb-8" />

          <motion.section initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}>
            <h2 className="font-heading font-extrabold text-[22px] text-[#0A0A0A] mb-6">Basic details</h2>
            <div className="grid grid-cols-2 gap-x-10 gap-y-8 mb-12">
              <Field label="Facility name" value="Burjeel-AlNahyan" delay={0.3} />
              <Field label="Category"       value="Provider"         delay={0.35} />
              <Field label="Type"           value="Hospital"          delay={0.4} />
              <Field label="Sub Type"       value="N/A"               delay={0.45} />
            </div>
          </motion.section>

          <motion.section initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 }}>
            <h2 className="font-heading font-extrabold text-[22px] text-[#0A0A0A] mb-6">Facility information</h2>
            <div className="grid grid-cols-2 gap-x-10 gap-y-8">
              <Field label="Local number"   value="N/A"              delay={0.55} />
              <Field label="Location"       value="Abu Dhabi"        delay={0.6} />
              <Field label="Address"        value="Al Nhayan Street" delay={0.65} />
              <Field label="License number" value="B2323"            delay={0.7} />
              <Field label="Organisation"   value="Burjeel"          delay={0.75} />
            </div>
          </motion.section>
        </div>
      </div>
    </PortalShellV2>
  );
}
